const getters = {
  getUsuario: (state) => state.usuario,
};

export default getters;
